import React from 'react'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import { Button } from 'src/Components'
import BombBombControlButton from 'src/App/BombBomb/ControlButton'
import { IconAngleLeft } from 'src/Components/Icon'

import styles from './AgentNavigation.module.scss'

const AgentNavigation = ({ backLink }) => (
  <div className={classnames(styles.container, !backLink && styles.loading)}>
    <div className={styles.left}>
      <Button iconStart={IconAngleLeft} element='a' href={backLink}>
        <FormattedMessage
          id='Navigation.customerProfile.backToClient'
          defaultMessage='Back to client'
        />
      </Button>
    </div>
    <div className={styles.right}>
      <BombBombControlButton className={styles.bombBombControl} />
    </div>
  </div>
)

export default AgentNavigation
